import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  extractErrorMessage(error: HttpErrorResponse): string {
    const payload = error.error as any;

    if (payload?.error?.error) {
      return payload.error.error;
    }

    if (payload?.errors && typeof payload.errors === 'object') {
      const messages = Object.values(payload.errors)
        .flat()
        .filter((msg): msg is string => typeof msg === 'string');
      if (messages.length > 0) {
        return messages.join('\n');
      }
    }

    if (payload?.status?.message) {
      const msg = payload.status.message;
      if (typeof msg === 'object') {
        return Object.values(msg).flat().join('\n');
      }
      return msg;
    }

    return 'An unexpected error occurred.';
  }

  extractFieldErrors(error: HttpErrorResponse): Record<string, string> {
    const payload = error.error as any;
    const fieldErrors: Record<string, string> = {};

    if (payload?.errors && typeof payload.errors === 'object') {
      Object.keys(payload.errors).forEach((field) => {
        const messages = payload.errors[field];
        if (Array.isArray(messages) && typeof messages[0] === 'string') {
          fieldErrors[field] = messages[0];
        }
      });
    }

    return fieldErrors;
  }
}
